// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const porygon: PokeData = {
  "id": 137,
  "name": "porygon",
  "height": 8,
  "weight": 365,
  "base_experience": 79,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "psybeam",
    "hyper-beam",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "agility",
    "recover",
    "barrier",
    "sharpen",
    "conversion",
    "tri-attack",
    "conversion-2",
    "zap-cannon",
    "lock-on",
    "spark",
    "magic-coat",
    "recycle",
    "signal-beam",
    "magnet-rise",
    "discharge"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "thunderbolt",
    "tri-attack",
    "zap-cannon",
    "quick-attack",
    "purification",
    "protect",
    "refresh",
    "supersonic",
    "scary-face",
    "growl",
    "splash"
  ],
  "evolution_chain": {
    "id": 68,
    "item": null,
    "species": [
      {
        "name": "porygon",
        "order": 166,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "porygon2",
        "order": 167,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 137,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "porygon-z",
        "order": 168,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 233,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 68.75,
    "speed": 40,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
